import { AxiosRequestConfig } from 'axios';
import { URLS } from 'consts/api/urls';
import { useAxios, useAxiosFunctionality } from 'hooks/api/axios/utils';

export const useStocksAxios = (config: string | AxiosRequestConfig) => {
  const axiosClient = useAxios(URLS.STOCKS_ENDPOINT);
  return useAxiosFunctionality(axiosClient, config);
};
